import { useState } from "react";

export const useMobile = () => {
    const [isMobile] = useState(window.innerWidth < 768);
    return isMobile;
}